import type { FaireProductEntity } from "../../entity_types/product";

export const p_fvk84hsqk5: FaireProductEntity = {
  token: "p_fvk84hsqk5",
  type: "product",
  name: "Chirps and Cheers Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/87b73ced4f4fc0e678e4c2ceb58a3cecd443b80f7f2c5cc6ec92d21af65a17b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d66499109cafa2ab351a8adaed01148b28447372ad67987f793e35a339eabe5.jpeg",
    "https://cdn.faire.com/fastly/69c432d24927a1a6d7662fe8108365fcc0f68794bb64f3d34d8f9cb98811ef46.jpeg",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:29.915Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
